import { useDispatch, useSelector } from 'react-redux';
import {
  closeAllSideBarAccordions,
  onToggleAccordion,
  selectIsRouteActive,
  selectIsSidebarOpen,
  SideBarMenuItem,
  SideBarSubMenuItem
} from './sidebarSlice';
import { NavLink, useLocation } from 'react-router-dom';
import { RootState } from 'app/store';
import { Fragment } from 'react';

const menuItemStyle = 'h-14 cursor-pointer flex items-center px-8 mx-2';
const memuItemStyleMinimal =
  'h-14 cursor-pointer flex items-center justify-center px-8 mx-5 md:px-2.5 md:m-2.5';

const SideBarMenuItemComponent = ({
  menuItem
}: {
  menuItem: SideBarMenuItem;
}) => {
  const dispatch = useDispatch();

  const location = useLocation();
  const currentPathName = location.pathname.substring(
    location.pathname.indexOf('/') + 1
  );

  const isSidebarOpen = useSelector(selectIsSidebarOpen);

  const isRouteActive = useSelector((state: RootState) =>
    selectIsRouteActive(state, currentPathName, menuItem)
  );

  const getIconColour = (
    currentPathName: string,
    sidebarItem: SideBarMenuItem
  ): string => (isRouteActive ? 'text-tertiary-600' : '');

  const getButtonColour = (
    currentPathName: string,
    sidebarItem: SideBarMenuItem
  ): string => (isRouteActive ? 'bg-navy-dark' : '');

  return (
    <>
      {menuItem.subMenuItems.length < 1 ? (
        <NavLink
          onClick={() => dispatch(closeAllSideBarAccordions())}
          title={menuItem.title}
          to={menuItem.path ?? '*'}
          className=" text-off-gray mb-2 block"
        >
          <div
            key={`sidebar-single-${menuItem.title}`}
            className={`transition-all ${
              isRouteActive ? 'backdrop-brightness-125' : ''
            } ${
              isSidebarOpen ? menuItemStyle : memuItemStyleMinimal
            }  ${getButtonColour(
              currentPathName,
              menuItem
            )} rounded hover:backdrop-brightness-125`}
          >
            <i
              className={`flex items-center justify-center w-6 transition-all text-xl ${
                isSidebarOpen ? 'mr-5' : ''
              } ${getIconColour(currentPathName, menuItem)} ${menuItem.icon}`}
            ></i>
            <span
              className={`text-sm ${isSidebarOpen ? 'block' : 'md:hidden'}`}
            >
              {menuItem.title}
            </span>
          </div>
        </NavLink>
      ) : (
        <>
          <div
            title={menuItem.title}
            key={`sidebar-multi-${menuItem.title}`}
            className={`${
              isSidebarOpen
                ? `${menuItemStyle} justify-between`
                : `h-14 cursor-pointer flex items-center justify-center px-10 mx-5 md:px-2.5 md:mx-2.5 md:mt-2.5`
            } pr-5 transition-all ${
              menuItem.isSubMenuOpen ? 'bg-navy-dark rounded-b-none' : ''
            } ${getButtonColour(
              currentPathName,
              menuItem
            )} hover:backdrop-brightness-125 rounded text-off-gray`}
            onClick={() =>
              dispatch(onToggleAccordion({ menuItemId: menuItem.id }))
            }
          >
            <span className="flex items-center">
              <i
                className={`flex items-center justify-center w-6 transition-all text-xl ${
                  isSidebarOpen ? 'mr-5' : ''
                } ${getIconColour(currentPathName, menuItem)} ${menuItem.icon}`}
              ></i>
              <span className="text-sm">
                {isSidebarOpen ? menuItem.title : ''}
              </span>
            </span>
            <span>
              {isSidebarOpen ? (
                <i
                  className={`ra-icons-generic-down-arrow text-xs flex flex-row transition-all 
      ${menuItem.isSubMenuOpen ? 'rotate-180' : 'rotate-0'}`}
                ></i>
              ) : null}
            </span>
          </div>
          <div
            className={
              `flex-col transition-all overflow-hidden ` +
              (menuItem.isSubMenuOpen ? 'max-h-screen' : 'max-h-0') +
              (isSidebarOpen ? ' mb-2' : '')
            }
          >
            <div className="flex-col rounded">
              {menuItem.subMenuItems.map(
                (childItem: SideBarSubMenuItem, childIndex: number) => {
                  return (
                    <Fragment key={`nav-${childItem.id}`}>
                      <NavLink
                        to={childItem.path}
                        className={`${
                          isSidebarOpen ? menuItemStyle : memuItemStyleMinimal
                        } pl-14 text-off-gray bg-navy-dark hover:bg-navy hover:brightness-125 transition-all ${
                          childIndex === menuItem.subMenuItems.length - 1
                            ? 'rounded-b'
                            : ''
                        }`}
                      >
                        <div
                          className="text-sm"
                          key={`side-menu-child-item-${childItem.id}`}
                        >
                          {isSidebarOpen ? childItem.title : ''}
                        </div>
                      </NavLink>
                    </Fragment>
                  );
                }
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default SideBarMenuItemComponent;
